import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class PublicInterestMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.publicInterest.publicInterestMapperError"));

        Object.setPrototypeOf(this, PublicInterestMapperError.prototype);
    }
}